import { mapSFToForm } from 'app/services/sfAuth/sfDataService'
import { SurveyTranslation, surveyTranslationFieldsMapSF } from './SurveyTranslation'

export const faqFieldsMapSF = {
  direction: 'in',
  Id: 'id',
  Name: 'name',
  Question__c: 'questionId',
  Question__r: {
    key: 'question',
    in: (obj) => {
      return (
        obj.Question__r != null
          ? mapSFToForm(surveyTranslationFieldsMapSF, obj.Question__r)
          : []
      )
    }
  },
  Answer__c: 'answerId',
  Answer__r: {
    key: 'answer',
    in: (obj) => {
      return (
        obj.Answer__r != null
          ? mapSFToForm(surveyTranslationFieldsMapSF, obj.Answer__r)
          : []
      )
    }
  },
  Approver__c: 'approver',
  Where_to_start__c: 'whereToStart',
  Category__c: 'category',
  Status__c: 'status',
  Display_Location__c: 'displayLocation',
  LastModifiedBy: {
    key: 'lastModifiedBy',
    in: (obj) => {
      return obj.LastModifiedBy != null
        ? obj.LastModifiedBy.Name
        : null
    }
  },
  LastModifiedDate: 'lastModifiedDate',
  Category_sort_order__c: 'categorySortOrder'
}

export interface Faq {
  id: string
  name: string
  questionId: string
  question: SurveyTranslation
  answerId: string
  answer: SurveyTranslation
  whereToStart: string
  category: string
  status: string
  displayLocation: string
  lastModifiedBy: string
  lastModifiedDate: string
  approver: string
  categorySortOrder: number
}
